import actionTypes from '../actions/actionTypes'
import { AnyAction } from 'redux'
import appActions from '../actions/appActions'

const postMessage = (payload: any) => {
	if (window && window.top) {
		window.top.postMessage(
			{
				action_type: 'EXTERNAL_SLIDE/EVENT',
				type: 'nearpodMessage',
				payload,
			},
			'*'
		)
	}
}

const characterSelected = (action: AnyAction) => {
	postMessage({
		event_name: actionTypes.CHARACTERS_SELECT,
		value: action.id,
	})
}

const postGameEnd = () => {
	postMessage({
		event_name: actionTypes.GAME_END,
	})
}

const postMessageMiddleware = (store: any) => {
	window.addEventListener('message', function (e) {
		if (e.data.type === 'nearpodMessage') {
			switch (e.data.action_type) {
				case actionTypes.SESSION_SETTINGS_HIDE_STUDENT_NAMES_UPDATE:
					store.dispatch(appActions.hideStudentNamesUpdate(e.data.hideStudentNames))
					break
				default:
					break
			}
		}
	})

	return (next: (action: unknown) => unknown) => (rawAction: unknown) => {
		const action = rawAction as AnyAction
		next(action)
		switch (action.type) {
			case actionTypes.CHARACTERS_SELECT:
				characterSelected(action)
				break
			case actionTypes.GAME_END:
				postGameEnd()
				break
		}
	}
}

export default postMessageMiddleware
